// extracted by mini-css-extract-plugin
export var errorIcon = "_og-1";
export var nameLogo = "_og-0";